import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { LevelQuestion } from 'bookraw/shared/models/level-question.model';
import { environment } from 'env/environment';

@Injectable()
export class LevelQuestionsService extends ListService<LevelQuestion> {

  url: string = '/api/admin/levelQuestions';

  import(data: FormData) {
    return this.http.post(environment.baseURL + this.url + '/import', data)
  }
}
